import Button from 'react-bootstrap/Button';
import React from 'react'
import {useParams} from 'react-router-dom';



function CertificateView() {
    const {id} = useParams();
  const {name} = useParams();
  const {cert} = useParams();
  return (
   
    <div >
      <br/>
        <h2>Hello {name} ...!</h2>
        <br/>
        <h3>
            Team Id: {id}
            </h3>
            <div  style={{ display: 'flex', margin: 'auto', padding: 40 ,background:'#F8F8F8'}} >

           
           <img style={{margin: 'auto',background:'#F8F8F8',width:300,height:230}} src={"https://drive.google.com/uc?id="+cert+"&export=download"}/>
           </div>
           <div style={{display: 'flex',margin: 'auto',background:'#F8F8F8',width:300}}>
           <br/>
           <Button variant="primary" href= {"https://instagram.com/iotclub_vnr?igshid=MWI4MTIyMDE="} target="_blank">Follow us on Instagram</Button>
           <h1>&nbsp;&nbsp;</h1>
         
            <Button variant="primary" href= {"https://drive.google.com/uc?id="+cert+"&export=download"}>Download Certificate</Button>
            </div>
            </div>

            
  )
}

export default CertificateView